var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SubHeaderBlock'),(_vm.spinnerShow && !_vm.$route.params.id)?_c('b-spinner',{staticClass:"spinner",attrs:{"label":"Large Spinner"}}):_vm._e(),_c('div',{staticClass:"container"},[_c(_vm.block,{tag:"component",on:{"spinner":function($event){_vm.spinnerShow = false}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }